import React from 'react'
import { MdEdit } from 'react-icons/md'
import { useNavigate, useLocation } from 'react-router-dom'
import { PiToggleLeftFill } from 'react-icons/pi'
import { IoNotificationsCircle } from "react-icons/io5";

export const ClinicSidebar = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    return (
        <div className='w-full h-full'>
            <div className='h-[90%] flex flex-col justify-center items-center w-full'>
                <div className='flex flex-col gap-2 w-full'>
                    <div className={`flex w-full items-center justify-around rounded-lg border-2 border-[#888] py-4 cursor-pointer ${pathname.includes('/edit') ? "border-blue-500" : ''} `} onClick={() => navigate(`/clinics/edit/1`)}>
                        <MdEdit />
                        <h2 className='text-black '>Edit Details</h2>
                    </div>
                    <div className={`flex w-full items-center justify-around rounded-lg border-2 border-[#888] py-4 cursor-pointer ${pathname.includes('/status') ? "border-blue-500" : ''} `} onClick={() => navigate(`/clinics/status/1`)}>
                        <PiToggleLeftFill />
                        <h2 className='text-black '>Clinic Status</h2>
                    </div>
                    <div className={`flex w-full items-center justify-around rounded-lg border-2 border-[#888] py-4 cursor-pointer ${pathname.includes('/notification') ? "border-blue-500" : ''}`} onClick={() => navigate(`/clinics/notification/1`)} >
                        <IoNotificationsCircle />
                        <h2 className='text-black '>Notification</h2>
                    </div>
                </div>
            </div>
            <button onClick={() => navigate("/")} className=' text-white h-fit bg-[conic-gradient(at_bottom_right,_var(--tw-gradient-stops))] from-blue-900  to-blue-500 w-fit rounded-lg px-7 py-1 shadow-xl'>
                Logout
            </button>
        </div>
    )
}
